import { render, staticRenderFns } from "./schoolsIndex.vue?vue&type=template&id=60ea9313&"
import script from "./schoolsIndex.vue?vue&type=script&lang=js&"
export * from "./schoolsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports